import { render, staticRenderFns } from "./findPWD.vue?vue&type=template&id=9c97fabe&"
import script from "./findPWD.vue?vue&type=script&lang=js&"
export * from "./findPWD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports